import { render, staticRenderFns } from "./PrivacyPolicyContent.vue?vue&type=template&id=38b1ada2&scoped=true"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyContent.vue?vue&type=style&index=0&id=38b1ada2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1ada2",
  null
  
)

export default component.exports